import styled, { css } from 'styled-components';
import { DynamicLink } from 'packages/smart-home-support/components';
import { BREAKPOINT_MOBILE, BREAKPOINT_DESKTOP, BREAKPOINT_LARGE_DESKTOP } from '../constants';
import { getPartnerCode } from 'packages/smart-home-support/partner';
import { Partner } from 'packages/smart-home-support/api/models';

const partner = getPartnerCode();

export default styled(DynamicLink)<{ isVisible: boolean }>`
  display: flex;
  justify-content: left;
  align-items: center;
  flex-grow: 1;
  align-self: center;
  height: 100%;
  position: relative;
  transition: top 0.2s, opacity 0.2s;
  padding-right: 10px;
  padding-left: 20px;
  width: 100%;
  max-width: 265px;
  box-sizing: border-box;
  ${
    partner !== Partner.Sprint
      ? `@media ${BREAKPOINT_DESKTOP} {
      padding: 0;
      margin-left: 10px;
      max-width: 296px;
    }`
      : ``
  }
  @media ${BREAKPOINT_LARGE_DESKTOP} {
    padding: 0;
    margin-left: 10px;
    max-width: 296px;
  }
  ${(props: { isVisible: boolean }) =>
    props.isVisible
      ? css`
          top: 0;
          opacity: 1;
        `
      : css`
          @media ${BREAKPOINT_MOBILE} {
            top: -100%;
            opacity: 0;
          `};
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Header/components/HeaderLogoLink.tsx